import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://registantours.com';

const HreflangTags = ({ path }) => {
  const basePath = path || '/';
  const enUrl = SITE_URL + basePath;
  const ruUrl = SITE_URL + '/ru' + (basePath === '/' ? '' : basePath);
  const uzUrl = SITE_URL + '/uz' + (basePath === '/' ? '' : basePath);

  return (
    <Helmet>
      <link rel="alternate" hreflang="en" href={enUrl} />
      <link rel="alternate" hreflang="ru" href={ruUrl} />
      <link rel="alternate" hreflang="uz" href={uzUrl} />
      <link rel="alternate" hreflang="x-default" href={enUrl} />
    </Helmet>
  );
};

export default HreflangTags;
